import ApolloClient from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-link';
import localStore from 'store'; // cross-browser local storage
import EVENTS from './helpers/customEvents';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URL,
});

const authLink = setContext((_, { headers }) => {
  const token = localStore.get('jwt');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : null,
    },
  };
});

const unauthorizedLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    if (response.errors) {
      // Check if any error is an unauthorized error
      const hasUnauthorizedError = response.errors.some(
        error => error.extensions?.code === 'UNAUTHENTICATED'
          || error.message.includes('unauthorized')
      );

      if (hasUnauthorizedError) {
        window.dispatchEvent(EVENTS.unauthorized);
      }
    }
    return response;
  });
});

const mockLinks = () => {
  if (process.env.NODE_ENV === 'production') return [];
  if (process.env.REACT_APP_MOCK_ONBOARDING_QUEUE !== 'true') return [];
  // eslint-disable-next-line global-require
  const { createOnboardingQueueMockLink } = require('./devMocks/onboardingQueue/link');
  return [createOnboardingQueueMockLink()];
};

const link = ApolloLink.from([...mockLinks(), unauthorizedLink, authLink, httpLink]);

const cache = new InMemoryCache({
  dataIdFromObject: o => (o.__typename && o.id ? `${o.__typename}:${o.id}` : null),
  cacheRedirects: {
    Query: {
      transaction: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'transaction', id: args.id }),
    },
  },
});

const client = new ApolloClient({
  link,
  cache,
});

export default client;
